import React, { Component } from 'react';
import axios from 'axios';
import Select from 'react-select'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'

// koneksi
import { PostMain, GetMain, DeleteMain } from '../../function/Koneksi';

// css files
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const formInput = {
	uuid:"",
	status: "",
	version: "",
	jenis_aplikasi: "",
	keterangan: "",
}

function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
		return new VersionApp(loader)
	}
}

class VersionApp extends Component {

	constructor(props) {
		super(props);
		this.loader = props;
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah Version App",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',
			dataCari: '',
			loadingPreview: false,
			//ckeditor
			content: '',
			responnya: [],
			
			frmJenisApp: [],
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// =================================================

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
				  link =
					"?page=" +
					Math.ceil(
					  this.state.pagination.total / this.state.pagination.per_page
					);
				  break;
				case ">":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
				  break;
				case "<":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
				  break;
				case "<<":
				  link = "?page=1";
				  break;
				default:
				  link = "?page=" + params.page;
				  break;
			  }
		}

		if(params.page){
			link = link + '&q=' + this.state.dataCari	
		}
		else{
			link = link + '?q=' + this.state.dataCari	
		}

		GetMain('master/version-app' + link, null, (lihat) => {
			if (lihat.results.data) {
				this.setState({ 
					data: lihat.results.data, 
					pagination: lihat.results,
					loadingPreview: false
				});
				this.pagination(lihat.results);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			
			this.setState({ 
				dataCari: e.target.value, 
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}

	simpan = e => {
		e.preventDefault();

		this.setState({
			loadingPreview: true,
			status:{
				...this.state.status,
				btnForm: true,
			}
		})

		if(
			this.state.dt.jenis_aplikasi &&
			this.state.dt.version &&
			this.state.dt.status &&
			this.state.dt.keterangan

		){
			let addData = {
				...this.state.dt,
				jenis_aplikasi: this.state.dt.jenis_aplikasi.value,
				status: this.state.dt.status.value,
			};

			let psn = '';
			let resstat = 204;
			let metode = "create";
			if (addData.uuid === '') {
				psn = "Tambah";
				resstat = 200;
				addData.uuid = null;

			}
			else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			PostMain('master/version-app/' + metode, addData.uuid, addData, (res) => {
				this.state.status.btnForm = false;
				this.state.status.form = false;
				this.forceUpdate();
				if (res.status === resstat) {
					this.setState({ 
						loadingPreview: false,
						show: true, 
						basicType: 'success', 
						basicTitle: 'Data Version App', 
						pesanAlert: 'Berhasil ' + psn + ' Data' 
					});
				}
				else {
					this.setState({ 
						loadingPreview: false,
						show: true, 
						basicType: 'danger', 
						basicTitle: 'Data Version App', 
						pesanAlert: 'Gagal ' + psn + ' Data' 
					});
				}
				this.componentDidMount();
			});
		}
		else{
			this.setState({ 
				status:{
					...this.state.status,
					btnForm: false,
				},
				loadingPreview: false,
				show: true, 
				basicType: 'danger', 
				basicTitle: 'Data Version App', 
				pesanAlert: 'Data Tidak Lengkap!' 
			});
		}
	}

	detailData = (data) => {
		// this.state.status.btnAksi = true;
		this.state.judul = "Detail Version App";
		this.setState({
			status:{
				form: true,
				detail: true,
			},
			dt:{
				uuid:data.uuid,
				version: data.version,
				keterangan: data.keterangan,
				jenis_aplikasi: { value: data.data_jenis_aplikasi.uuid, label: data.data_jenis_aplikasi.nama },
				status: { value: data.status, label: data.status === "Aktif"?"Aktif":"Tidak Aktif"},	
			}
		})
		this.forceUpdate();
		this.bukaForm('detail');
	}

	ubahData = (data) => {
		this.state.judul = "Edit Version App";
		this.setState({
			status:{
				form: true,
			},
			dt:{
				uuid:data.uuid,
				version: data.version,
				keterangan: data.keterangan,
				jenis_aplikasi: { value: data.data_jenis_aplikasi.uuid, label: data.data_jenis_aplikasi.nama },
				status: { value: data.status, label: data.status === "Aktif"?"Aktif":"Tidak Aktif"},	
			}
		})
		this.forceUpdate();
		this.bukaForm('edit');

	}

	konfirmHapus = (id) => {
		this.setState({
			alert: (
				<SweetAlert
					showCancel
					confirmBtnText="Hapus"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="success"
					type="danger"
					title="Yakin ingin hapus data ?"
					onCancel={this.hideAlert}
					onConfirm={() => this.hapusData(id)}
				>
					Proses ini tidak dapat dibatalkan!
				</SweetAlert>
			)
		});
	}

	hapusData = (id) => {
		this.hideAlert();
		let psn = "Hapus";
		this.setState({
			loadingPreview: true
		})
		DeleteMain('master/version-app/delete', id, (res) => {
			if (res == 200) {
				this.setState({ 
					loadingPreview: false,
					show: true, 
					basicType: 'success', 
					basicTitle: 'Data Version App', 
					pesanAlert: 'Berhasil ' + psn + ' Data' 
				});
			}
			else {
				this.setState({ 
					loadingPreview: false, 
					show: true, 
					basicType: 'danger', 
					basicTitle: 'Data Version App', 
					pesanAlert: 'Gagal ' + psn + ' Data' 
				});
			}
			this.componentDidMount();
		})
	}

	bukaForm = (e) => {
		if (e == 'tambah') {
			this.setState({
				dt:formInput,
			})
		}
		this.state.status.form = true;
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	tombolAksi = (cell, row) => {
		return (
			<>
				
				<Button size="xs" color="primary" className="btn-eye" onClick={() => this.detailData(row)}><i className="fa fa-eye"></i></Button> &nbsp;&nbsp;
				{/* <Button title="View detail" onPress={() => this.navigateToDetailPage(row.uuid)} /> */}
				<Button size="xs" color="success" className="btn-icon" onClick={() => this.ubahData(row)} disabled={this.state.status.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
				<Button size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-trash"></i></Button>
			</>
		)
	}
	componentDidMount() {
		this.fetch({ page: null, where: [] });

		GetMain("main/web/jenis-aplikasi/list", null, data => {
			if (data.result) {
				let frmJenisApp = [];
				data.result.map(dt => {
					frmJenisApp.push({ value: dt.uuid, label: dt.nama });
				});
				this.setState({ frmJenisApp });
			}
		});
	}
	
	// =================== END COMBO BOX JENIS PANDUAN ====================

	// =========== CKEDITOR 5 =============
	upload() {
		return new Promise((resolve, reject) => {

			const data = new FormData();

			this.loader.file.then(result => {
				data.append('files[]', result);
				// this.xhr.send(data);

				axios.post(localStorage.getItem('API_URL') + "upload-file-multiple/galery", data).then(res => {

					if (res.data.results) {

						// this.state.gambarnya = res.data.results[0];


						const xhr = res.data;
						const loader = this.loader;
						const genericErrorText = 'Couldn\'t upload file:' + ` ${loader.file.name}.`;

						// xhr.code('404', () => reject(genericErrorText));
						// xhr.addEventListener('abort', () => reject());
						const response = xhr.code;

						if (response != 200) {
							reject(genericErrorText)
						}
						else if (this.state.responnya.resp == 'Hapus') {
							reject()
						}
						else if (!response || response != 200) {
							return reject(response && response != 200 ? response.error.message : genericErrorText);
						}
						// If the upload is successful, resolve the upload promise with an object containing
						// at least the "default" URL, pointing to the image on the server.
						else if (response == 200)
							resolve({
								default: xhr.results[0]
							});
					}
				})
			})
		})
	}

	// Aborts the upload process.
	abort() {
		if (this.xhr) {
			this.xhr.abort();

			this.setState({
				responnya: { code: '406', resp: 'Hapus' }
			});
		}
	}

	// =========== END CKEDITOR 5 =============

	// =================== CKEDITOR5 ==========================
	handleCKEditor = (event, editor) => {
		const data = editor.getData();

		this.setState({
			dt: {
				...this.state.dt,
				keterangan: data
			}
		})
	}
	// =================== END CKEDITOR5 ==========================

	//============== SHOW DETAIL CKEDITOR RESULT ==================
	createMarkup = () => {
		return { __html: this.state.content };
	}
	//============= END SHOW DETAIL CKEDITOR RESULT===========

	render() {
		var data = this.state.data;
		const formInput = {
			uuid:"",
			status: "",
			version: "",
			jenis_aplikasi: "",
			keterangan: "",
		}

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
						align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'data_jenis_aplikasi.nama',
				text: 'Jenis Aplikasi',
				sort: true
			},
			{
				dataField: 'version',
				text: 'Version',
				sort: true
			},
			{
				dataField: 'status',
				text: 'Status',
				sort: true
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				isDummyField: true,
				csvExport: false,
				formatter: this.tombolAksi,
			},
		];

		const custom_config = {
			extraPlugins: [MyCustomUploadAdapterPlugin],
			// plugins: [ImageResize],
			toolbar: {
				items: [
					'heading',
					'|',
					'bold',
					'italic',
					'link',
					'bulletedList',
					'numberedList',
					'|',
					'blockQuote',
					'insertTable',
					'|',
					'imageUpload',
					'undo',
					'redo'
				]
			},
			image: {
				// resizeUnit: 'px',
				toolbar: [
					'imageStyle:full',
					'imageStyle:side',
					'|',
					'imageTextAlternative',
				]
			},
			table: {
				contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
			}
		}

		return (
			<div>
				<Breadcrumb title="Version App" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-6">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari}
												onKeyPress={this.cariData}
											/>
										</div>
										<div className="col-sm-6 text-right">
											<Button 
												size="sm" 
												color="success" 
												className="btn-square" 
												onClick={() => {
													this.setState({ 
														judul: "Tambah Version App", 
														dt: formInput 
													}); 
													this.bukaForm('tambah'); 
												}}>
													Tambah Data
												</Button>
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "75%", maxWidth: 'unset' } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.dt.uuid} />

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jenis Aplikasi</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={e => { this.handleSelectChange(e,"jenis_aplikasi")}}
										value={this.state.dt.jenis_aplikasi}
										name="jenis_aplikasi"
										options={this.state.frmJenisApp}
										placeholder="Pilih Jenis Aplikasi"
										isClearable
										isDisabled={this.state.status.detail?true:false}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Version</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="version" 
										type="text" 
										placeholder="Contoh: 3.1.1" 
										defaultValue={this.state.dt.version} 
										onChange={e => this.handleInputChange(e, "version")}
										required={true}
										readOnly={this.state.status.detail?true:false}
										style={this.state.status.detail ? { backgroundColor: "#F2F2F2" } : { backgroundColor: "" }}
									/>
								</Col>
							</FormGroup>
							
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Keterangan</Label>
								<Col sm='9'>
									<CKEditor
										required
										editor={Editor}
										config={custom_config}
										onChange={this.handleCKEditor}
										data={this.state.dt.keterangan}
										disabled={this.state.status.detail?true:false}
									/>
								</Col>
							</FormGroup>

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Status</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={(e) => this.handleSelectChange(e, 'status')}
										value={this.state.dt.status}
										name="status"
										options={[
											{ value: 'Aktif', label: 'Aktif' },
											{ value: 'Tidak Aktif', label: 'Tidak Aktif' },
										]}
										placeholder="Pilih Status"
										isClearable
										isDisabled={this.state.status.detail?true:false}
									/>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
							{
								this.state.status.detail?
								<></>
								:
								<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
							}
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default VersionApp;
